<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('androidMessageSet.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="title-box">
                <div class="title">{{ $t('iosMessageSet.p0') }}</div>
                <div class="title-text">{{ $t('iosMessageSet.p1') }}</div>
            </div>
            <div class="text">{{ $t('iosMessageSet.p72') }} <span class="bold">{{ $t('iosMessageSet.p73') }}</span>{{ $t('iosMessageSet.p74') }}<span class="bold">{{ $t('iosMessageSet.p75') }}</span>{{ $t('iosMessageSet.p76') }}</div>
            <div class="text">{{ $t('iosMessageSet.p77') }} <span class="bold">{{ $t('iosMessageSet.p78') }}</span></div>
            <img :src="require(`@/assets/theme/light/article/iosMessageSet/i7${l}.png`)">
            <div class="text"><span class="bold">{{ $t('iosMessageSet.p79') }}</span></div>
            <div class="text">{{ $t('iosMessageSet.p80') }} </div>
            <div class="text">{{ $t('iosMessageSet.p81') }} <span class="bold">{{ $t('iosMessageSet.p82') }}</span>{{ $t('iosMessageSet.p83') }} </div>
            <img :src="require(`@/assets/theme/light/article/iosMessageSet/i8${l}.png`)">
            <div class="text">{{ $t('iosMessageSet.p84') }} <span class="bold">{{ $t('iosMessageSet.p85') }}</span>{{ $t('iosMessageSet.p86') }}<span class="bold">{{ $t('iosMessageSet.p87') }}</span>{{ $t('iosMessageSet.p88') }}<span class="bold">{{ $t('iosMessageSet.p89') }}</span>{{ $t('iosMessageSet.p90') }}<span class="bold">{{ $t('iosMessageSet.p91') }}</span>{{ $t('iosMessageSet.p92') }} </div>
            <img :src="require(`@/assets/theme/light/article/iosMessageSet/i9${l}.png`)">
            <div class="line"></div>

            <div class="text">{{ $t('iosMessageSet.p45') }}<span class="bold">{{ $t('iosMessageSet.p46') }}</span>{{ $t('iosMessageSet.p47') }}<span class="bold">{{ $t('iosMessageSet.p48') }}</span>{{ $t('iosMessageSet.p49') }}
            </div>
            <div class="text">{{ $t('iosMessageSet.p50') }} <span class="bold">{{ $t('iosMessageSet.p55') }}</span>
                {{ $t('iosMessageSet.p56') }} <span class="bold">{{ $t('iosMessageSet.p57') }}</span>{{ $t('iosMessageSet.p58') }}
            </div>
            <img :src="require(`@/assets/theme/light/article/iosMessageSet/i10${l}.png`)">

            <div class="text">{{ $t('iosMessageSet.p2') }} <span class="bold">{{ $t('iosMessageSet.p3') }}</span> {{ $t('iosMessageSet.p4') }} <span class="bold">{{ $t('iosMessageSet.p5') }}</span> {{ $t('iosMessageSet.p6') }}</div>
            <div class="text">{{ $t('iosMessageSet.p7') }}<span class="bold">{{ $t('iosMessageSet.p8') }}</span>{{ $t('iosMessageSet.p9') }} <span class="bold">{{ $t('iosMessageSet.p10') }}</span>
                {{ $t('iosMessageSet.p11') }}<span class="bold">{{ $t('iosMessageSet.p12') }}</span> {{ $t('iosMessageSet.p13') }} <span class="bold"> {{ $t('iosMessageSet.p14') }}</span> {{ $t('iosMessageSet.p15') }} <span
                    class="bold"> {{ $t('iosMessageSet.p16') }}</span>{{ $t('iosMessageSet.p17') }}
            </div>
            <div class="text">{{ $t('iosMessageSet.p18') }} <span class="bold">{{ $t('iosMessageSet.p19') }}</span> {{ $t('iosMessageSet.p20') }} <span class="bold">{{ $t('iosMessageSet.p21') }}</span>{{ $t('iosMessageSet.p22') }}</div>
            <img :src="require(`@/assets/theme/light/article/iosMessageSet/i1${l}.png`)">
            <div class="text">{{ $t('iosMessageSet.p23') }} <span class="bold">{{ $t('iosMessageSet.p24') }}</span> {{ $t('iosMessageSet.p25') }} <span class="bold">{{ $t('iosMessageSet.p26') }}</span>{{ $t('iosMessageSet.p27') }}</div>
            <img :src="require(`@/assets/theme/light/article/iosMessageSet/i2${l}.png`)">
            <div class="text">{{ $t('iosMessageSet.p28') }}<span class="bold">{{ $t('iosMessageSet.p29') }}</span> {{ $t('iosMessageSet.p30') }} <span class="bold"> {{ $t('iosMessageSet.p31') }}</span> {{ $t('iosMessageSet.p32') }}<span
                class="bold">{{ $t('iosMessageSet.p33') }}</span> {{ $t('iosMessageSet.p34') }} <span class="bold">{{ $t('iosMessageSet.p35') }}</span>{{ $t('iosMessageSet.p36') }}
            </div>
            <img :src="require(`@/assets/theme/light/article/iosMessageSet/i3${l}.png`)">
            <div class="text">
                {{ $t('iosMessageSet.p59') }}
            </div>
            <div class="text">{{ $t('iosMessageSet.p60') }}<span class="bold">{{ $t('iosMessageSet.p61') }}</span>{{ $t('iosMessageSet.p62') }}</div>
            <div class="text"><span class="bold">{{ $t('iosMessageSet.p63') }}</span>{{ $t('iosMessageSet.p64') }}</div>
            <div class="text"><span class="bold">{{ $t('iosMessageSet.p65') }}</span>{{ $t('iosMessageSet.p66') }}</div>
            <div class="text"><span class="bold">{{ $t('iosMessageSet.p67') }}</span>{{ $t('iosMessageSet.p68') }}<span class="bold">{{ $t('iosMessageSet.p69') }}</span>{{ $t('iosMessageSet.p70') }}</div>
            <img class="i6" :src="require(`@/assets/theme/light/article/iosMessageSet/i6${l}.png`)">
            <div class="text">{{ $t('iosMessageSet.p71') }}</div>
        </div>
    </div>
</template>

<script>
import {getQueryVariable} from '@/utils/comment'

export default {
    name: 'iosMessageSet',
    data() {
        return {
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            l: getQueryVariable("lang") == 'en' ? "en" : "",
        }
    },
}
</script>

<style scoped>
    .banner {
        background-color: var(--bg-color-2) !important;
    }

    .content {
        background: var(--bg-color-2) !important;
        padding-bottom: 20px;
    }

    .title-box {
        margin: 0 12px 5px;
        width: 351px;
        background: var(--bg-color-1);
        border-radius: 6px 6px 6px 6px;
    }

    .title {
        padding-top: 9px;
        margin: 0 9px;
        font-size: 12px;
        font-weight: bold;
        line-height: 20px;
    }

    .title-text {
        font-size: 12px;
        line-height: 20px;
        margin: 0 9px;
        padding-bottom: 5px;
    }

    .text {
        margin: 0 21px;
        font-size: 12px;
        line-height: 20px;
    }

    .bold {
        font-weight: bold;
    }

    .content img {
        width: 345px;
        margin-left: 15px;
    }

    .i6 {
        width: 160px;
        margin-left: 107px;
        margin-top: 10px;
    }

    .line {
        height: 1px;
        width: 336px;
        margin: 10px auto;
        border-bottom: 1px solid #C8C8C8;
    }
</style>



// WEBPACK FOOTER //
// src/views/article/iosMessageSet.vue